// extracted by mini-css-extract-plugin
export var active = "styles-module--active--ba8f9";
export var bottom = "styles-module--bottom--56743";
export var bottomBottom = "styles-module--bottomBottom--5c243";
export var bottomTop = "styles-module--bottomTop--24473";
export var col1 = "styles-module--col1--e9601";
export var col2 = "styles-module--col2--e963e";
export var col3 = "styles-module--col3--0b646";
export var container = "styles-module--container--bebc0";
export var top = "styles-module--top--eb403";